import React from 'react';

import { Interval, DateTime } from 'luxon';

import MapWidget from './MapWidget.js';
import ControlWidget from './ControlWidget.js'
import TornadoCollection from './TorCollection.js';
import f_scale_partitioner from './Partitioner.js';
import {DATA_LIMITS} from './Constants.js';
import SelectionInterval from './SelectionInterval.js';
import MapOverlayWidget from './MapOverlayWidget.js';
import options from './json/options.json';

import './App.css';


class TornadoArchiveApp extends React.Component {
    constructor(props) {
        super(props);

        this.base_tor_collection = null;
        this.partitioner = f_scale_partitioner;

        const intv = new SelectionInterval(Interval.after(this.props['default_day'].plus({'hours': 12}), {'hours': 24}));

        this.state = {
            'interval': intv,
            'timeline_tbnds': intv.getPaddedInterval(),
            'filters': {},

            'tor_collection': null,
        };

        this.ss_funcs = {};
        this.set_screenshot_func = this.set_screenshot_func.bind(this);
    }

    componentDidMount() {
        let url_base = '/data';
        if (options['build'] == 'dev') {
            url_base = '/dev/data';
        }

        TornadoCollection.fromServer(url_base + '/tornadoes_' + this.props['default_day'].toFormat('yyyyMMdd') + '.json.gz').then(tor_coll => {
            this.base_tor_collection = tor_coll;
            this.setState({'tor_collection': tor_coll.applyFilters(this.state['filters'])});

            const now = DateTime.utc();
            return TornadoCollection.fromServer(url_base + '/tornadoes.json.gz?' + now.toISO());
        }).then(tor_coll =>{
            this.base_tor_collection = tor_coll;
            this.setState({'tor_collection': tor_coll.applyFilters(this.state['filters'])});
        });
    }

    onintervalchange(intv, recenter_timeline) {
        if (recenter_timeline) {
            this.setState({'interval': intv, 'timeline_tbnds': intv.getPaddedInterval()});
        }
        else {
            this.setState({'interval': intv});
        }
    }

    ontboundschange(tbnds) {
        this.setState({'timeline_tbnds': new SelectionInterval(tbnds)});
    }

    onfilterchange(new_filters) {
        new_filters = {...this.state['filters'], ...new_filters};
        new_filters = Object.fromEntries(Object.entries(new_filters).filter(([k, v]) => v !== null));

        let new_state = {'filters': new_filters}

        if (this.base_tor_collection !== null) {
            new_state['tor_collection'] = this.base_tor_collection.applyFilters(new_filters)
        }

        this.setState(new_state);
    }

    screenshot() {
        // Poll all the child components for screenshots
        const promise_map = this.ss_funcs['map']().then(data_map => {
            const prom_map = new Promise((resolve, reject) => {
                let img = new Image();
                img.onload = () => resolve(img);

                img.src = data_map;
            })
            return prom_map;
        })

        const promise_overlay = this.ss_funcs['overlay']().then(data_overlay => {
            const prom_overlay = new Promise((resolve, reject) => {

                let img = new Image();
                img.onload = () => resolve(img);

                img.src = data_overlay;
            })

            return prom_overlay;
        });

        const promise_timeline = new Promise((resolve, reject) => {
            const data = this.ss_funcs['timeline']();

            let img = new Image();
            img.onload = () => resolve(img);

            img.src = data;
        })

        // Composite them and open a new window
        Promise.allSettled([promise_map, promise_overlay, promise_timeline]).then(results => {
            const map_img = results[0]['value'];
            const overlay_img = results[1]['value'];
            const timeline_img = results[2]['value'];

            const full_width = map_img.width;
            const full_height = map_img.height + timeline_img.height + 4;

            let canvas = document.createElement('canvas');
            canvas.width = full_width;
            canvas.height = full_height;

            let ctx = canvas.getContext('2d');
            ctx.beginPath();
            ctx.fillStyle = '#ffffff';
            ctx.rect(0, 0, full_width, full_height);
            ctx.fill();

            ctx.drawImage(map_img, 0, 0);
            ctx.drawImage(overlay_img, 0, 0);
            ctx.drawImage(timeline_img, 0, map_img.height + 4);

            const data = canvas.toDataURL();

            const header = "<head><title>Tornado Archive Screenshot</title></head>";
            const iframe = "<body><img width='100%' src='" + String(data) + "'></body>";

            let win = window.open();
            if (win !== null) {
                win.document.open();
                win.document.write(header + iframe);
                win.document.location = '#';
                win.document.close();
            }
        });
    }

    set_screenshot_func(ss_func, which) {
        this.ss_funcs[which] = ss_func;
    }
    
    render() {
        return (
            <div id="main">
                <MapWidget 
                    interval={this.state['interval']}
                    tor_coll={this.state['tor_collection']}
                    partitioner={this.partitioner}

                    setscreenshotfunc={this.set_screenshot_func}
                />
                <MapOverlayWidget
                    interval={this.state['interval']}
                    tor_coll={this.state['tor_collection']}
                    filters={this.state['filters']}

                    setscreenshotfunc={this.set_screenshot_func}
                />
                <ControlWidget 
                    interval={this.state['interval']}
                    tor_coll={this.state['tor_collection']}
                    partitioner={this.partitioner}
                    filters={this.state['filters']}
                    timeline_tbnds={this.state['timeline_tbnds']}
                    timeline_limits={DATA_LIMITS}
                    data_limits={DATA_LIMITS}

                    onintervalchange={this.onintervalchange.bind(this)}
                    onfilterchange={this.onfilterchange.bind(this)}
                    ontboundschange={this.ontboundschange.bind(this)}
                    onscreenshot={this.screenshot.bind(this)}

                    setscreenshotfunc={this.set_screenshot_func}
                />
            </div>
        );
    }
}

export default TornadoArchiveApp;
